// import type { Plugin } from 'vue'

import { forEach } from "lodash-es"
import CryptoJS from 'crypto-js'
/**
 *
 * @param component 需要注册的组件
 * @param alias 组件别名
 * @returns any
 */
export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any
  comp.install = (app: any) => {
    app.component(comp.name || comp.displayName, component)
    if (alias) {
      app.config.globalProperties[alias] = component
    }
  }
  return component as T & Plugin
}

/**
 * @param str 需要转下划线的驼峰字符串
 * @returns 字符串下划线
 */
export const humpToUnderline = (str: string): string => {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase()
}

/**
 * @param str 需要转驼峰的下划线字符串
 * @returns 字符串驼峰
 */
export const underlineToHump = (str: string): string => {
  if (!str) return ''
  return str.replace(/\-(\w)/g, (_, letter: string) => {
    return letter.toUpperCase()
  })
}

export const setCssVar = (prop: string, val: any, dom = document.documentElement) => {
  dom.style.setProperty(prop, val)
}

/**
 * 查找数组对象的某个下标
 * @param {Array} ary 查找的数组
 * @param {Functon} fn 判断的方法
 */
// eslint-disable-next-line
export const findIndex = <T = Recordable>(ary: Array<T>, fn: Fn): number => {
  if (ary.findIndex) {
    return ary.findIndex(fn)
  }
  let index = -1
  ary.some((item: T, i: number, ary: Array<T>) => {
    const ret: T = fn(item, i, ary)
    if (ret) {
      index = i
      return ret
    }
  })
  return index
}

export const trim = (str: string) => {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * @param {Date | number | string} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time: Date | number | string, fmt: string) {
  if (!time) return ''
  else {
    const date = new Date(time)
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  }
}

/**
 * 生成随机字符串
 */
export function toAnyString() {
  const str: string = 'xxxxx-xxxxx-4xxxx-yxxxx-xxxxx'.replace(/[xy]/g, (c: string) => {
    const r: number = (Math.random() * 16) | 0
    const v: number = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString()
  })
  return str
}


/**
 * Date格式转换
 */
 export function formatDate (inputDate:any, fmt='YYYY-mm-dd HH:MM:SS') {
  if (!inputDate) {
    return ""
  }
  let ret:any
  const date = new Date(inputDate)
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt)
    if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    }
  }
  return fmt
}

/**
 * 币种映射
 */
export function TransCurrency(val:any) {
  switch (val) {
    case 1:
      return '¥'
    default:
      return '¥'
  }
}

/**
 * file转base64
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    let res:any = "";
    reader.readAsDataURL(file)
    reader.onload = function() {
      res = reader.result
    };
    reader.onerror = function(err) {
      reject("")
    }
    reader.onloadend = function() {
      resolve(res)
    }
  })
}


/**
 * list结构数据转换成tree结构
 */
export function listToTree(input:any[], idKeyName='id', parentKeyName='parent_id', childKeyName='children'):any[] {
  function findChild(node:any, list:any[], idKeyName:string, parentKeyName:string, childKeyName:string):any {
    for (const item of list) {
      if (node[idKeyName].toString() === item[parentKeyName].toString()) {
        if (!node[childKeyName]) {
          node[childKeyName] = <any>[]
        }
        node[childKeyName].push(findChild(item, list, idKeyName, parentKeyName, childKeyName))
      }
    }
    return node
  }
	// 先找出跟节点，然后递归的找跟节点的所有child
	const res:any[] = []
  for (const item of input) {
    if (item[parentKeyName].toString() === '0') {
      res.push(findChild(item, input, idKeyName, parentKeyName, childKeyName))
    }
  }
	return res
}

/**
 * 寻找dom元素的子节点
 */
export function serachDomChild(childClassName:string, srcDom:any, dstArr:any) {
  const classList = srcDom.classList
  if (classList.contains(childClassName)) dstArr.push(srcDom)
  const children = srcDom.children
  if (!children || children.length === 0) return
  for (const child of children) {
    serachDomChild(childClassName, child, dstArr)
  }
}

export function copyTextToClipboard(content) {
  const input = document.createElement("input") // 创建input对象
  input.value = content // 设置复制内容
  document.body.appendChild(input) // 添加临时实例
  input.select() // 选择实例内容
  document.execCommand("Copy") // 执行复制
  document.body.removeChild(input) // 删除临时实例
}

/**
 * 计算字符串的字符数
 * 数字 48-57
 * 大写英文 65-90
 * 小写英文 97-122
 */
export function strCodeLen(str) {
  let count = 0
  const charArr = str.split('')
  charArr.forEach(item => {
    const charCode = item.charCodeAt()
    // 数字
    if (charCode >= 0 && charCode <= 128) count += 1
    else count += 2
  })
  return count
}

// 动态替换favicon
export function changeFavicon(iconUrl) {
  // console.log('changeFavicon:', iconUrl)
  let $favicon:any = document.querySelector('link[rel="icon"]')
  if ($favicon !== null) {
    $favicon.href = iconUrl
  } else {
    $favicon = document.createElement("link");
    $favicon.rel = "icon"
    $favicon.href = iconUrl
    document.head.appendChild($favicon)
  }
}

//aes 加密
export function AESEncrypt (pwd, user) {
  if(user){
    user = user.toLowerCase()
  }
  const AESKey = CryptoJS.MD5(user).toString();
  const key = CryptoJS.enc.Utf8.parse(AESKey);
  const iv = CryptoJS.enc.Utf8.parse(AESKey.substring(0, 16)); // 偏移量：规定的是key前15位
  const srcs = CryptoJS.enc.Utf8.parse(pwd);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

export function base64ToBlob (code) {
  const parts = code.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for(let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], {
      type: contentType
  });
}

// 将文件转为base64编码
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    let fileResult:any = "";
    reader.readAsDataURL(file);
    reader.onload = function() {
      fileResult = reader.result;
    }
    reader.onerror = function(error) {
      reject("");
    }
    reader.onloadend = function() {
      resolve(fileResult);
    }
  })
}

export async function urlToFile(url,fileName,mimeType:any=null) {
  const response = await fetch(url);
  // Ensure the response is successful
  if (!response.ok) {
    console.error('Failed to fetch file:', response.statusText);
    return null
  }
  
  // Get the file's Blob
  const blob = await response.blob();
  
  // Convert Blob to File
  const file = new File([blob], fileName, { type: mimeType?mimeType:blob.type });
  
  return file;
}

export function joinPaths(...paths) {
  return paths
    .map((p, index) => {
      // 去除每个路径部分末尾的斜杠，避免重复斜杠
      p = p.replace(/\/$/, '');  // 去掉末尾的斜杠
      // 如果不是第一个路径，并且不是以斜杠开头，就加上一个斜杠
      if (index > 0 && p && !p.startsWith('/')) {
        return '/' + p;
      }
      return p;
    })
    .join(''); // 拼接时不再添加多余的斜杠
}

/**
 * 将字节数转成字符串并配置合适的单位
 * @param bytes 字节数
 * @returns 
 */
export function calcFileSizeStr(bytes:number) {
  let str:any = ''
  if (bytes >= 1024 * 1024 * 1024) {
    str = (bytes / (1024 * 1024 * 1024)).toFixed(1) + " GB";
  } else if (bytes >= 1024 * 1024) {
    str = (bytes / (1024 * 1024)).toFixed(1) + " MB";
  } else if (bytes >= 1024) {
    str = (bytes / 1024).toFixed(1) + " KB";
  } else {
    str = bytes + " B";
  }
  return str
}

export function readFile(file,format='txt') {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = (e:any) => {
      const content = e?.target.result
      resolve(content)
    }
    if (format === 'dataUrl') reader.readAsDataURL(file)
    else if (format === 'arrayBuffer') reader.readAsArrayBuffer(file)
    else reader.readAsText(file)
  })
}

export function fetchSSEAsPromise(url, options:any = {}, timeout=10000, onMessage) {
  return new Promise(async (resolve, reject) => {
    const controller = new AbortController();

    // ⏱ 超时自动中止
    const timer = setTimeout(() => {
      controller.abort();
      reject(new Error('请求超时'));
    }, timeout);

    try {
      const response:any = await fetch(url, {
        ...options,
        headers: {
          'Accept': 'text/event-stream',
          ...options.headers
        },
        credentials: 'include',
        signal: controller.signal
      });
      clearTimeout(timer);

      if (!response.ok) {
        return reject(new Error(`HTTP error! status: ${response.status}`));
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer:any = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          console.log('Stream closed.');
          return resolve(null); // 成功完成
        }

        buffer += decoder.decode(value, { stream: true });

        const parts = buffer.split('\n\n');
        buffer = parts.pop(); // 保留不完整的部分

        for (const part of parts) {
          const lines = part.trim().split('\n');
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const jsonStr = line.slice(6);
              try {
                const parsed = JSON.parse(jsonStr);
                onMessage?.(parsed); // 调用回调
              } catch (e) {
                console.warn('Invalid JSON:', jsonStr);
              }
            }
          }
        }
      }
    } catch (error) {
      reject(error);
    }
  });
}

export const checkUrlAccessibility = async (url, timeout=5000) => {
  const controller = new AbortController();
  const signal = controller.signal;
  
  // 设置超时时间
  const timeoutId = setTimeout(() => {
    controller.abort(); // 超时后取消请求
  }, timeout); // 5秒超时
  
  try {
    const response = await fetch(url, {
      method: 'HEAD',
      mode: 'cors',
      cache: 'no-cache',
      signal // 关联 AbortController
    });
    
    // 清除超时计时器
    clearTimeout(timeoutId);
    
    // 检查状态码
    console.log('response',response)
    return response.ok || (response.status >= 200 && response.status < 400);
  } catch (error:any) {
    // 清除超时计时器
    clearTimeout(timeoutId);
    
    // 处理超时错误或其他网络错误
    if (error.name === 'AbortError') {
      console.error('URL 检查超时:', url);
    } else {
      console.error('检查 URL 访问性时出错:', error);
    }
    return false;
  }
};
